import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Projects from './components/Projects';
import ReadyMade from './components/ReadyMade';
import WhyChoose from './components/WhyChoose';
import TechStack from './components/TechStack';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import LegalModal from './components/LegalModal';
import ProgressBar from './components/ProgressBar';
import { ShaderBackground } from '@/components/ui/shader-b3e94fd7';

function App() {
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);
  const [activeLegalPage, setActiveLegalPage] = useState('privacy');

  const openLegalModal = (page: string) => {
    setActiveLegalPage(page);
    setIsLegalModalOpen(true);
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden text-foreground selection:bg-svnate-teal selection:text-black">
      {/* Persistent Background */}
      <div className="fixed inset-0 z-0">
        <ShaderBackground className="absolute inset-0" />
      </div>

      {/* Content wrapper */}
      <div className="relative z-10 w-full min-h-screen bg-transparent">
        <ProgressBar />
        <Navbar />
        <main className="flex flex-col w-full bg-transparent gap-8 md:gap-12">
          <Hero />
          <Services />
          <Process />
          <Projects />
          <ReadyMade />
          <WhyChoose />
          <TechStack />
          <FAQ />
          <Contact />
        </main>
        <div className="h-8 md:h-12" /> {/* Gap before footer */}
        <Footer openLegalModal={openLegalModal} />
        <WhatsAppButton />
        
        <LegalModal 
          isOpen={isLegalModalOpen} 
          activePage={activeLegalPage} 
          onClose={() => setIsLegalModalOpen(false)} 
        />
      </div>
    </div>
  );
}

export default App;
